if (!customElements.get('logos-slider')) {
  class LogosSlider extends HTMLElement {
    selectors = {
      slider: '.swiper',
    };

    constructor() {
      super();
    }

    connectedCallback() {
      this.elements = {
        slider: this.querySelector(this.selectors.slider),
      };

      this.settings = {
        slidesPerView: this.hasAttribute('slider-slides-per-view')
          ? this.getAttribute('slider-slides-per-view')
          : 'auto',
        centerInsufficientSlides: false,
        loop: true,
        loopedSlides: 3,
        autoplay: this.hasAttribute('slider-autoplay')
          ? {
              delay: this.getAttribute('slider-autoplay'),
            }
          : false,
        breakpoints: {
          140: {
            centeredSlides: false,
            centerInsufficientSlides: false,
          },
          768: {
            centeredSlides: false,
            centerInsufficientSlides: true,
            slidesPerView: 'auto',
          },
        },
      };

      this.slider = new Swiper(this.elements.slider, this.settings);

      if (Shopify.designMode) {
        this.addEventListener(
          'shopify:block:select',
          this.handleBlockSelect.bind(this),
        );
      }
    }

    /**
     * Handle Shopify admin section block select.
     * @param {Object} e Event
     */
    handleBlockSelect(e) {
      const targetIndex = Number(e.target?.getAttribute('data-slide-index'));

      if (!Number.isNaN(targetIndex)) {
        this.slider.slideTo(targetIndex);
      }
    }
  }
  customElements.define('logos-slider', LogosSlider);
}
